import type { Tab } from '../store/state';
import { useApp } from '../store/useApp';

const TABS: ReadonlyArray<[Tab, string]> = [
  ['practice', 'Practice'],
  ['topics', 'Topics'],
  ['tools', 'Tools'],
  ['wins', 'Wins'],
  ['cards', 'Cards'],
];

export function TabBar() {
  const { state, dispatch } = useApp();

  return (
    <nav
      style={{
        flex: 'none',
        display: 'flex',
        padding: '8px 12px max(10px, env(safe-area-inset-bottom))',
        gap: 4,
        background: 'var(--nav)',
        borderTop: '1px solid var(--line)',
      }}
    >
      {TABS.map(([id, name]) => {
        const active = state.tab === id;
        return (
          <button
            key={id}
            type="button"
            aria-current={active ? 'page' : undefined}
            onClick={() => dispatch({ type: 'setTab', tab: id })}
            style={{
              flex: 1,
              minHeight: 48,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 5,
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              font: '600 11px/1 var(--font-body)',
              color: active ? 'var(--text)' : 'var(--text-4)',
              transition: 'color var(--motion)',
            }}
          >
            <div
              aria-hidden
              style={{
                width: active ? 18 : 6,
                height: 6,
                borderRadius: 999,
                background: active ? 'var(--lime)' : 'rgba(255,255,255,.2)',
                transition: 'width var(--motion), background var(--motion)',
              }}
            />
            <div>{name}</div>
          </button>
        );
      })}
    </nav>
  );
}
